import { render, staticRenderFns } from "./PhoneBurger.vue?vue&type=template&id=0b3d36c8&"
import script from "./PhoneBurger.vue?vue&type=script&lang=js&"
export * from "./PhoneBurger.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBurger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports